module.exports = __webpack_public_path__ + "img/slider-13.add4014e.jpg";